import React from 'react'
import './Info.css';

const Info = () => {
  return (
    <div className="fourth-sec">
    <div className="section-four">
      <div className="sec-four-content">
        <h5 className="num">567</h5>
        <p>Agent and Agency</p>
      </div>
      <div className="sec-four-content">
        <h5 className="num">12168</h5>
        <p>Happy Customers Every Year</p>
      </div>
      <div className="sec-four-content">
        <h5 className="num">2172</h5>
        <p>Won Awards</p>
      </div>
      <div className="sec-four-content">
        <h5 className="num">734</h5>
        <p>New Listing Every Week</p>
      </div>
    </div>
  </div>
  )
}

export default Info